import { FC } from 'react';

const OrganizationIcon: FC = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6C7.65685 6 9 4.65685 9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6Z" fill="currentColor"/>
      <path d="M13.5 7C14.8807 7 16 5.88071 16 4.5C16 3.11929 14.8807 2 13.5 2C12.1193 2 11 3.11929 11 4.5C11 5.88071 12.1193 7 13.5 7Z" fill="currentColor"/>
      <path d="M0.61528 14.428C0.217975 14.1736 -0.0121527 13.721 0.0460496 13.2529C0.414158 10.292 2.93944 8 5.9999 8C9.06036 8 11.5856 10.2914 11.9537 13.2522C12.012 13.7203 11.7818 14.1729 11.3845 14.4273C9.83022 15.4225 7.98243 16 5.9999 16C4.01737 16 2.16959 15.4231 0.61528 14.428Z" fill="currentColor"/>
      <path d="M13.5001 14C13.4647 14 13.4295 13.9998 13.3943 13.9993C13.4631 13.7025 13.4822 13.3885 13.4423 13.0671C13.2668 11.6562 12.7001 10.367 11.854 9.31165C12.3646 9.11049 12.9208 9 13.5028 9C15.4426 9 17.0956 10.2273 17.7279 11.9478C17.8638 12.3176 17.7045 12.7241 17.3671 12.9275C16.2379 13.6083 14.9147 14 13.5001 14Z" fill="currentColor"/>
    </svg>
  );
};

export default OrganizationIcon;
